module.exports = __webpack_public_path__ + "static/serengeti-eyewear-100a21c48bc5aa724381b8a4ade3ec91.jpg";